import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { mergeClassNames } from '../../../utils';
import { iconMap } from './iconMap';
const Icon = ({ icon, id, title, message, place, effect, className, tooltipClassName, allowHtml, onClick, }) => {
    const classes = mergeClassNames(className, 'flex items-center');
    const tooltipClasses = mergeClassNames(tooltipClassName, 'max-w-xl');
    return (_jsxs("span", { "data-for": id, "data-tip": message, className: classes, onClick: onClick, children: [_jsx("title", { children: title }), iconMap[icon], message ? (_jsx(ReactTooltip, { id: id, place: place, effect: effect, className: tooltipClasses, html: allowHtml })) : null] }));
};
Icon.propTypes = {
    icon: PropTypes.string.isRequired,
    id: PropTypes.string,
    title: PropTypes.string,
    message: PropTypes.string,
    place: PropTypes.string,
    effect: PropTypes.string,
    className: PropTypes.string,
    tooltipClassName: PropTypes.string,
    allowHtml: PropTypes.bool,
};
Icon.defaultProps = {
    id: '',
    title: '',
    message: '',
    place: 'bottom',
    effect: 'solid',
    className: '',
    tooltipClassName: '',
    allowHtml: false,
};
export default Icon;
